import { render, staticRenderFns } from "./systemlog.vue?vue&type=template&id=60b7d46b&scoped=true&"
import script from "./systemlog.vue?vue&type=script&lang=js&"
export * from "./systemlog.vue?vue&type=script&lang=js&"
import style0 from "./systemlog.vue?vue&type=style&index=0&id=60b7d46b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7d46b",
  null
  
)

export default component.exports